import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  host: { class: 'app-loader' }
})
export class LoaderComponent implements OnInit {

  @Input('disabled') disabled:boolean
  @Input('big') big:boolean
  @Input('no-bg') noBg:boolean

  constructor() { }

  ngOnInit(): void {
  }

}
